module.exports = __webpack_public_path__ + "static/media/CapsLockTechnologies.0ecdb5c5.png";